<template>
  <!-- Modal for software infos -->
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="450px"
             top="30vh">
    <div class="confirm-container">
      <div class="confirm-tip"><span :class="type">!</span>
        {{ type==='info'?languages.addInfo:languages.failInfo }}
      </div>
      <div class="confirm-content">{{ type==='info'?languages.info:languages.failTip }}</div>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button v-if="type==='warn'"
                 style="width:130px"
                 @click="GoHelpdesk">{{ languages.foHelp }}
      </el-button>
      <el-button class="button-confirm"
                 type="primary"
                 @click="Confirm">{{languages.confirm }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  inject: ['gridTemplate'],
  props: {
    languages: Object,
    type: String,
    show: Boolean,
  },
  methods: {
    GoHelpdesk () {
      window.location = this.languages.service;
      this.gridTemplate.hideAutoAdminDialog();
    },
    Confirm () {
      this.gridTemplate.hideAutoAdminDialog();
    },
  },
};
</script>

<style lang="scss" scoped></style>
